import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Package, ShoppingBag, Settings, CreditCard, BarChart2, LogOut, Users, FileText, MessageSquare, BookOpen } from '../../lib/lucide-proxy';
import { useAuth } from '../../contexts/AuthContext';

const AdminSidebar = () => {
  const location = useLocation();
  const { profile, signOut } = useAuth();
  
  const isAdmin = profile?.role === 'admin';

  const navigation = [
    { name: 'Dashboard', href: '/admin', icon: LayoutDashboard },
    { name: 'Produtos', href: '/admin/products', icon: Package },
    { name: 'Pedidos', href: '/admin/orders', icon: ShoppingBag },
    // Admin Only Items merged intelligently
    ...(isAdmin ? [
      { name: 'Contas', href: '/admin/accounts', icon: Users },
      { name: 'Enciclopédia', href: '/admin/encyclopedia', icon: BookOpen }, // Added here
    ] : []),
    { name: 'Blog', href: '/admin/blog', icon: FileText },
    { name: 'Avaliações', href: '/admin/reviews', icon: MessageSquare },
    ...(isAdmin ? [] : [{ name: 'Meus Posts', href: '/admin/posts', icon: FileText }]), // Split Blog management vs Post submission
    { name: 'Assinatura', href: '/admin/billing', icon: CreditCard },
    { name: 'Relatórios', href: '/admin/reports', icon: BarChart2 },
    { name: 'Configurações', href: '/admin/settings', icon: Settings },
  ];

  const isActive = (path) => {
    if (path === '/admin' && location.pathname === '/admin') return true;
    if (path !== '/admin' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <div className="hidden md:flex flex-col w-64 bg-dark-900 border-r border-dark-800 min-h-screen sticky top-0 h-screen">
      <div className="flex items-center justify-center h-16 border-b border-dark-800 flex-shrink-0">
        <Link to="/" className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-sm">C</span>
          </div>
          <span className="font-display font-bold text-xl text-cream-300">
            Cerveja <span className="text-primary-500">Delivery</span>
          </span>
        </Link>
      </div>

      <div className="flex-1 overflow-y-auto py-4 custom-scrollbar">
        <nav className="px-2 space-y-1">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md transition-colors ${
                isActive(item.href)
                  ? 'bg-primary-500 text-white'
                  : 'text-gray-400 hover:bg-dark-800 hover:text-white'
              }`}
            >
              <item.icon
                className={`mr-3 h-5 w-5 flex-shrink-0 ${
                  isActive(item.href) ? 'text-white' : 'text-gray-500 group-hover:text-gray-300'
                }`}
              />
              {item.name}
            </Link>
          ))}
        </nav>
      </div>

      <div className="border-t border-dark-800 p-4 flex-shrink-0">
        <button
          onClick={() => signOut()}
          className="flex items-center w-full px-2 py-2 text-sm font-medium text-red-400 rounded-md hover:bg-dark-800 transition-colors"
        >
          <LogOut className="mr-3 h-5 w-5" />
          Sair
        </button>
      </div>
    </div>
  );
};

export default AdminSidebar;